import _ from 'underscore';

export const generateLighterColorSequences = (initialColors, shades = 8, ordered = false) => {
  const increments = [10, 11, 12, 13, 14, 15, 16, 17, 18];
  const colorSequences = [];

  initialColors.forEach((initialColor) => {
    let currentColor = [
      parseInt(initialColor.substring(1, 3), 16),
      parseInt(initialColor.substring(3, 5), 16),
      parseInt(initialColor.substring(5, 7), 16)
    ];
    let colorSequence = [initialColor];

    _.times(shades, (i) => {
      const nextColor =
        currentColor.map((component) => Math.min(255, Math.max(0, component + increments[i])));

      const nextColorHex =
        `#${nextColor.map((component) => component.toString(16).padStart(2, '0')).join('')}`;
      colorSequence.push(nextColorHex);
      currentColor = nextColor;
    });

    if (ordered && colorSequence.length <= 9) {
      const indexes = [1, 9, 5, 2, 6, 4, 8, 3, 7];
      colorSequence = indexes.map((index) => colorSequence[index - 1]);
    }

    colorSequences.push(colorSequence);
  });

  if (ordered) {
    return colorSequences.reduce((acc, subArray) => {
      subArray.forEach((element, index) => {
        if (acc[index] === undefined) {
          acc[index] = [];
        }
        acc[index].push(element);
      });
      return acc;
    }, []);
  }

  return colorSequences;
};
